module.exports = __webpack_public_path__ + "static/media/pecuaria-banner.e2da7509.jpg";